import ClientService, {SubscribeClient} from "app/Service/Client/ClientService"
import ToolbarView from "app/WebView/Toolbar/ToolbarView"
import {ToolbarButtons} from "app/WebView/Toolbar/ToolbarView.model"
import {Module} from "const/Module"
import Logger from "logger/logger"
import React, {useMemo} from "react"

function InvoiceGeneralSettingsButtons() {

  const {clientEditDefaultSettings, saveClientEdit, clearClientEdit} = ClientService([
    SubscribeClient.defaultSettings
  ], 'InvoiceGeneralSettingsButtons')

  const buttons = useMemo(() => {
    Logger('InvoiceGeneralSettingsButtons.render', clientEditDefaultSettings)
    const buttons: ToolbarButtons = {
      second: [{
        id: Module.invoiceDefaultSettings,
        type: 'save',
        disabled: undefined === clientEditDefaultSettings,
        onClick: () => {
          saveClientEdit()
        }
      }],
      third: [{
        id: Module.invoiceDefaultSettings,
        type: 'cancel',
        disabled: undefined === clientEditDefaultSettings,
        onClick: () => {
          clearClientEdit()
        }
      }]
    }

    return buttons
  }, [clientEditDefaultSettings])

  return <ToolbarView buttons={buttons}/>
}

export default InvoiceGeneralSettingsButtons
